import { gql } from '@/api/utils';
import { default as axios } from '@/api/axios';
import getSuggestedJurisdictionsQuery from '@docupet/component-library/src/api/query/getSuggestedJurisdictions.query';

export default {
  async getJurisdictionsByProvince(input) {
    try {
      const query = gql`
        query licensingCommunities($input: FindJurisdictionInput) {
          licensingCommunities(input: $input) {
            name
            organizationUrl
          }
        }
      `;

      const variables = { input };
      const { licensingCommunities: results } = await axios.post('/', { query, variables });

      return results;
    } catch (error) {
      return Promise.reject({
        message: error.message,
      });
    }
  },
  async getLicensingProvinces() {
    try {
      const query = gql`
        query licensingProvinces {
          licensingProvinces {
            province
          }
        }
      `;

      const { licensingProvinces: results } = await axios.post('/', { query });

      return results;
    } catch (error) {
      return Promise.reject({
        message: error.message,
      });
    }
  },
  async getSuggestedJurisdictions(input) {
    try {
      const variables = {
        input,
      };

      const { suggestJurisdictions: results } = await axios.post('/', {
        query: getSuggestedJurisdictionsQuery,
        variables,
      });

      return results;
    } catch (error) {
      return Promise.reject({
        message: error.message,
        code: error.message?.[0]?.extensions?.code,
      });
    }
  },
};
